import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Se tiver um ficheiro CSS global
import App from './App'; // Importa o seu componente principal App
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


reportWebVitals();
